import { Tag } from '../../interfaces/tag';
import { getAllJsonApiPages } from '../../utils/jsonApi';

// Large enough that an agent's tags come back in one request. Any extra
// pages (or a lower server-side cap) are still fetched by getAllJsonApiPages.
const TAGS_PAGE_SIZE = 100;

/** Fetches every tag on an agent from the internal JSON:API tags endpoint. */
export const fetchAgentTags = (agentId: string | number): Promise<Tag[]> =>
  getAllJsonApiPages<Tag>(`/internal/v1/agents/${agentId}/tags/`, {
    params: { 'page[size]': TAGS_PAGE_SIZE },
    numericIds: true,
  });
